import React from 'react';
import { Quote } from 'lucide-react';
import { assetUrl } from '../lib/api';

export const KenStory = ({ story }) => {
    if (!story?.body) return null;
    const photos = (story.photos || []).filter(Boolean);
    return (
        <section className="border-t border-neutral-200" data-testid="ken-story">
            <div className="container-page py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
                <div className="lg:col-span-5 grid grid-cols-2 gap-3" data-testid="ken-story-photos">
                    {photos.length === 0 && (
                        <div className="col-span-2 aspect-[4/5] border border-dashed border-neutral-300 bg-neutral-50 flex items-center justify-center text-sm text-neutral-400">
                            Add Ken&apos;s photos in Admin → Pages
                        </div>
                    )}
                    {photos.map((p, i) => (
                        <div key={i} className={`overflow-hidden border border-neutral-200 bg-neutral-100 ${i === 0 ? 'col-span-2' : 'aspect-square'}`}>
                            <img src={assetUrl(p)} alt={`Ken — photo ${i + 1}`} loading="lazy" className={i === 0 ? 'w-full h-auto block' : 'w-full h-full object-cover object-top'} data-testid={`ken-photo-${i}`} />
                        </div>
                    ))}
                </div>
                <div className="lg:col-span-7">
                    <div className="label-caps text-brand-primary mb-6">/ {story.eyebrow}</div>
                    <h2 className="font-display font-black uppercase tracking-tighter text-4xl md:text-6xl text-neutral-900 leading-[0.95]" data-testid="ken-story-heading">{story.heading}</h2>
                    <p className="mt-8 text-base md:text-lg text-neutral-700 leading-relaxed whitespace-pre-line" data-testid="ken-story-body">{story.body}</p>
                    {story.quote && (
                        <blockquote className="mt-10 border-l-4 border-brand-primary pl-6 py-2" data-testid="ken-story-quote">
                            <Quote className="h-6 w-6 text-brand-primary mb-2" />
                            <p className="font-display font-bold text-2xl text-neutral-900">{story.quote}</p>
                            <footer className="mt-2 label-caps text-xs text-neutral-500">— Ken, Founder</footer>
                        </blockquote>
                    )}
                </div>
            </div>
        </section>
    );
};

export const Timeline = ({ items }) => {
    if (!items?.length) return null;
    return (
        <section className="border-t border-neutral-200 bg-neutral-50" data-testid="about-timeline">
            <div className="container-page py-24 md:py-32">
                <div className="label-caps text-brand-primary mb-4">/ Timeline</div>
                <h2 className="font-display font-black uppercase tracking-tighter text-4xl md:text-6xl text-neutral-900 mb-16">How we got here</h2>
                <ol className="relative border-l-2 border-neutral-300 ml-3 space-y-14">
                    {items.map((t, i) => (
                        <li key={i} className="pl-10 relative" data-testid={`timeline-item-${i}`}>
                            <span className="absolute -left-[11px] top-1.5 h-5 w-5 rounded-full bg-brand-primary border-4 border-neutral-50" />
                            <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
                                <div className="md:col-span-7">
                                    <div className="font-display font-black text-4xl md:text-5xl text-brand-primary leading-none">{t.year}</div>
                                    <h3 className="mt-3 font-display font-bold uppercase text-xl text-neutral-900">{t.title}</h3>
                                    <p className="mt-2 text-neutral-600 leading-relaxed">{t.text}</p>
                                </div>
                                {t.image_url && (
                                    <div className="md:col-span-5 aspect-[4/3] overflow-hidden border border-neutral-200 bg-white">
                                        <img src={assetUrl(t.image_url)} alt={t.title} loading="lazy" className="w-full h-full object-cover object-top" />
                                    </div>
                                )}
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
};
